import SignUpBlock from './SignUpBlock';
import { SignUpBlockProps, SignUpBlockValueProps } from './types';

export type { SignUpBlockProps, SignUpBlockValueProps };
export default SignUpBlock;
